import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { confirm as confirmDialog } from 'react-bootstrap-confirmation';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { capitalize } from 'lodash';

const SyncStatus = ({
    propKeys,
    device,
    cancel,
}) => {
    const [hasChanges, setHasChanges] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [changes, setChanges] = useState([]);
    const [changeKeys, setChangeKeys] = useState([]);

    useEffect(() => {
        if (!propKeys || propKeys.length === 0) {
            setChangeKeys(['variables', 'tables', 'firmware']);
            return;
        }
        setChangeKeys([...propKeys]);
    }, [propKeys]);

    useEffect(() => {
        const changeList = [];
        if (device) {
            let newChangeStatus = false;
            if (device && device.changes) {
                for (let i = 0; i < changeKeys.length; i++) {
                    if (device.changes[changeKeys[i]]
                        && Object.keys(device.changes[changeKeys[i]]).length > 0) {
                        newChangeStatus = true;
                        const keys = Object.keys(device.changes[changeKeys[i]]);
                        for (let j = 0; j < keys.length; j++) {
                            if (typeof device.changes[changeKeys[i]][keys[j]] === 'object') {
                                changeList.push({
                                    ...device.changes[changeKeys[i]][keys[j]],
                                    key: keys[j],
                                    type: changeKeys[i],
                                });
                            } else {
                                changeList.push({
                                    key: keys[j],
                                    value: device.changes[changeKeys[i]][keys[j]],
                                    type: changeKeys[i],
                                });
                            }
                        }
                    }
                }
            }
            setHasChanges(newChangeStatus);
            setChanges(changeList);
        }
    }, [device, changeKeys]);

    const handleCancel = async (key) => {
        if (!await confirmDialog(`Cancel pending ${key} changes for ${device.name}?`)) {
            return;
        }
        cancel(key, device.deviceId);
        // setModalShow(false);
    };

    return (
        <>
            <div
                style={{
                    cursor: 'pointer',
                }}
                onClick={() => {
                    setModalShow(true);
                }}
            >
                {!hasChanges ? (
                    <span className="badge rounded-pill text-bg-success">
                        Synced
                    </span>
                ) : (
                    <span className="badge rounded-pill text-bg-secondary">
                        Not Synced
                    </span>
                )}
            </div>
            <Modal
                scrollable
                show={modalShow}
                onHide={() => setModalShow(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Pending changes
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        hasChanges ? (
                            <Tabs>
                                {
                                    changeKeys.map((changeKey, index) => {
                                        if (!device.changes
                                            || device.changes[changeKey] === undefined
                                            || Object
                                                .keys(device.changes[changeKey]).length === 0) {
                                            return null;
                                        }
                                        let tabChanges = Object
                                            .keys(device.changes[changeKey]).length;
                                        if (changeKey === 'firmware' && tabChanges > 0) {
                                            tabChanges = 1;
                                        }
                                        return (
                                            <Tab
                                                eventKey={index}
                                                title={(
                                                    <span className="">
                                                        {capitalize(changeKey)}
                                                        {tabChanges > 0 && (
                                                            <span className="badge ms-1 text-bg-danger">{tabChanges}</span>
                                                        )}
                                                    </span>
                                                )}
                                                key={index}
                                            >
                                                {tabChanges === 0 && (
                                                    <div className="p-3">
                                                        No pending changes
                                                    </div>
                                                )}
                                                {
                                                    changes.map((change, index) => {
                                                        let component = null;
                                                        if (change.type === changeKey && change.type === 'variables') {
                                                            component = (
                                                                <div
                                                                    className="m-3"
                                                                >
                                                                    <h5>{change.key}</h5>
                                                                    <div>
                                                                        <strong>
                                                                            Last Updated:
                                                                        </strong>
                                                                        &nbsp;
                                                                        <span>
                                                                            {new Date(
                                                                                change.updatedAt,
                                                                            ).toLocaleString()}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <strong>New Value:</strong>
                                                                        &nbsp;
                                                                        <span>{change.value}</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        if (change.type === changeKey && change.type === 'tables') {
                                                            component = (
                                                                <div
                                                                    className="m-3"
                                                                >
                                                                    <h5>{change.key}</h5>
                                                                    <div>
                                                                        <strong>Action:</strong>
                                                                        &nbsp;
                                                                        <span>{change.action}</span>
                                                                    </div>
                                                                    <div>
                                                                        <strong>Data:</strong>
                                                                        &nbsp;
                                                                        <span>{change.data}</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        if (change.type === changeKey && change.type === 'firmware') {
                                                            component = (
                                                                <div
                                                                    className="m-3"
                                                                >
                                                                    <strong>{change.key}</strong>
                                                                    <div>{change.value}</div>
                                                                </div>
                                                            );
                                                            if (change.key === 'url') {
                                                                component = (
                                                                    <div
                                                                        className="m-3"
                                                                    >
                                                                        <strong>
                                                                            File
                                                                        </strong>
                                                                        <div>
                                                                            <a
                                                                                href={change.value}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                {change.value.split('/').pop()}
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                        if (!component) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div key={index}>
                                                                {component}
                                                                <hr />
                                                            </div>
                                                        );
                                                    })
                                                }
                                                <div
                                                    className="d-flex justify-content-end mt-3"
                                                >
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => handleCancel(changeKey)}
                                                    >
                                                        {`Cancel ${capitalize(changeKey)} Changes`}
                                                    </Button>
                                                </div>
                                            </Tab>
                                        );
                                    })
                                }
                            </Tabs>
                        ) : (
                            <div
                                className="m-3 d-flex justify-content-center"
                            >
                                No pending changes
                            </div>
                        )
                    }
                </Modal.Body>
            </Modal>
        </>
    );
};

export default SyncStatus;
